/* eslint-disable no-nested-ternary */
import styled, { withTheme } from 'styled-components';
import { Tabs as MuiTabs } from '@material-ui/core';

const BlockTabs = styled(MuiTabs)`
  background: ${(props) => props.theme.palette.common.backgroundDark};

  ${(props) => props.theme.breakpoints.up('md')} {
    & .MuiTabs-indicator {
      background-color: transparent;
    }
  }
`;

export default withTheme(BlockTabs);
